import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

export const fetchInvoices = async (query) => {
  const { data } = await apiClient.get(`/invoices/${query.queryKey[1]}`);
  return data;
};

export const useGetInvoiceHandler = (id) => {
  const dispatch = useDispatch();
  const [invoice, setInvoice] = useState(undefined);

  const {
    data: fetchedData,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ['invoices', id], // A unique key for this query
    queryFn: fetchInvoices,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      setInvoice(fetchedData);
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    invoice: invoice,
    isLoading,
  };
};
